(function() {
  'use strict';

  const STORAGE_KEY = 'shopify-filters-drawer-open';
  let isDrawerOpen = false;

  // Ouvrir le drawer
  function openDrawer() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');

    if (drawer && overlay) {
      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('filters-drawer-open');
      isDrawerOpen = true;
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }
  }

  // Fermer le drawer
  function closeDrawer() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');

    if (drawer && overlay) {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }

    document.body.classList.remove('filters-drawer-open');
    isDrawerOpen = false;
    sessionStorage.removeItem(STORAGE_KEY);
  }

  // Restaurer sans animation
  function restoreDrawerState() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');
    const shouldBeOpen = sessionStorage.getItem(STORAGE_KEY) === 'true';

    if (shouldBeOpen && drawer && overlay) {
      // Ajouter une classe spéciale pour éviter l'animation lors de la restauration
      drawer.classList.add('no-transition');
      overlay.classList.add('no-transition');

      // Ajouter les classes d'état
      drawer.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('filters-drawer-open');
      isDrawerOpen = true;

      // Supprimer la classe no-transition après un délai très court
      setTimeout(function() {
        drawer.classList.remove('no-transition');
        overlay.classList.remove('no-transition');
      }, 50);
    } else if (!drawer || !overlay) {
      // Nettoyer si les éléments n'existent pas
      document.body.classList.remove('filters-drawer-open');
      sessionStorage.removeItem(STORAGE_KEY);
      isDrawerOpen = false;
    }
  }

  // Initialiser les événements
  function initializeEvents() {
    // Bouton d'ouverture
    const openBtn = document.querySelector('.open-filters-btn');
    if (openBtn && !openBtn.hasAttribute('data-drawer-initialized')) {
      openBtn.setAttribute('data-drawer-initialized', 'true');
      openBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    }

    // Bouton de fermeture
    const closeBtn = document.getElementById('filtersDrawerClose');
    if (closeBtn && !closeBtn.hasAttribute('data-drawer-initialized')) {
      closeBtn.setAttribute('data-drawer-initialized', 'true');
      closeBtn.addEventListener('click', function(e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    // Overlay
    const overlay = document.getElementById('filtersDrawerOverlay');
    if (overlay && !overlay.hasAttribute('data-drawer-initialized')) {
      overlay.setAttribute('data-drawer-initialized', 'true');
      overlay.addEventListener('click', function(e) {
        const drawer = document.getElementById('filtersDrawer');

        // Fermer si on clique directement sur l'overlay ou si le clic n'est pas dans le drawer
        if (e.target === overlay ||
            e.target.classList.contains('filters-drawer-overlay') ||
            !drawer || !drawer.contains(e.target)) {
          closeDrawer();
        }
      });
    }

    // Formulaire
    const form = document.getElementById('FacetsForm');
    if (form && !form.hasAttribute('data-drawer-initialized')) {
      form.setAttribute('data-drawer-initialized', 'true');
      form.addEventListener('change', function() {
        if (isDrawerOpen) {
          sessionStorage.setItem(STORAGE_KEY, 'true');
        }
      });
    }
  }

  // Fonction principale d'initialisation
  function init() {
    initializeEvents();
    restoreDrawerState();
  }

  // Écouter les mises à jour Shopify
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

  // Écouter la touche Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isDrawerOpen) {
      closeDrawer();
    }
  });

  // Observer les changements DOM pour détecter les nouveaux éléments
  const observer = new MutationObserver(function(mutations) {
    let hasNewDrawer = false;

    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 &&
            (node.id === 'filtersDrawer' || node.id === 'filtersDrawerOverlay' ||
                (node.querySelector && (node.querySelector('#filtersDrawer') || node.querySelector('#filtersDrawerOverlay'))))) {
          hasNewDrawer = true;
        }
      });
    });

    if (hasNewDrawer) {
      setTimeout(function() {
        // Nettoyer les styles inline potentiels des nouveaux éléments
        const newDrawer = document.getElementById('filtersDrawer');
        const newOverlay = document.getElementById('filtersDrawerOverlay');

        if (newDrawer && newDrawer.hasAttribute('style')) {
          newDrawer.removeAttribute('style');
        }
        if (newOverlay && newOverlay.hasAttribute('style')) {
          newOverlay.removeAttribute('style');
        }

        init();
      }, 50);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Nettoyage périodique des classes orphelines et styles inline
  setInterval(function() {
    const hasClass = document.body.classList.contains('filters-drawer-open');
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');

    if (hasClass && !drawer) {
      document.body.classList.remove('filters-drawer-open');
      sessionStorage.removeItem(STORAGE_KEY);
      isDrawerOpen = false;
    }

    // Nettoyer TOUS les styles inline sur les éléments drawer et overlay
    if (drawer && drawer.hasAttribute('style')) {
      drawer.removeAttribute('style');
      console.log('Removed inline styles from drawer');
    }
    if (overlay && overlay.hasAttribute('style')) {
      overlay.removeAttribute('style');
      console.log('Removed inline styles from overlay');
    }

    // Si l'overlay a des styles inline mais n'est pas censé être ouvert, les supprimer
    if (overlay && overlay.hasAttribute('style') && !sessionStorage.getItem(STORAGE_KEY)) {
      overlay.removeAttribute('style');
      overlay.classList.remove('active');
      console.log('Cleaned orphaned overlay styles');
    }
  }, 500); // Plus fréquent pour un nettoyage plus agressif

  // Fonctions debug globales
  window.drawerDebug = function() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');
    const shouldBeOpen = sessionStorage.getItem(STORAGE_KEY) === 'true';
    const bodyHasClass = document.body.classList.contains('filters-drawer-open');

    console.log('Drawer State:', {
      drawerExists: !!drawer,
      overlayExists: !!overlay,
      shouldBeOpen,
      isDrawerOpen,
      bodyHasClass,
      drawerHasInlineStyle: drawer ? drawer.hasAttribute('style') : false,
      overlayHasInlineStyle: overlay ? overlay.hasAttribute('style') : false,
      drawerStyle: drawer ? drawer.getAttribute('style') : null,
      overlayStyle: overlay ? overlay.getAttribute('style') : null
    });
  };

  window.drawerCleanup = function() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');

    document.body.classList.remove('filters-drawer-open');
    sessionStorage.removeItem(STORAGE_KEY);
    isDrawerOpen = false;

    if (drawer) {
      drawer.removeAttribute('style');
      drawer.classList.remove('active');
    }
    if (overlay) {
      overlay.removeAttribute('style');
      overlay.classList.remove('active');
    }

    console.log('Drawer cleaned and inline styles removed');
  };

  // Fonction globale pour nettoyer uniquement les styles inline
  window.cleanDrawerStyles = function() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');

    if (drawer && drawer.hasAttribute('style')) {
      drawer.removeAttribute('style');
      console.log('Cleaned drawer inline styles');
    }
    if (overlay && overlay.hasAttribute('style')) {
      overlay.removeAttribute('style');
      console.log('Cleaned overlay inline styles');
    }
  };

  // Fonction de nettoyage immédiat des styles inline
  function cleanupInlineStyles() {
    const drawer = document.getElementById('filtersDrawer');
    const overlay = document.getElementById('filtersDrawerOverlay');

    if (drawer && drawer.hasAttribute('style')) {
      drawer.removeAttribute('style');
      console.log('Cleaned inline styles from drawer at startup');
    }
    if (overlay && overlay.hasAttribute('style')) {
      overlay.removeAttribute('style');
      console.log('Cleaned inline styles from overlay at startup');
    }
  }

  // Démarrage
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      cleanupInlineStyles();
      init();
    });
  } else {
    cleanupInlineStyles();
    init();
  }

})();
